var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":_vm.iconColor,"width":_vm.iconSize,"height":_vm.iconSize,"id":"icon_hero","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }